import { useState, useEffect } from "react"
import { useHistory, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getUser } from "../store/actions/usersAction"

export default function Login() {
  const [UserLogin, setUserLogin] = useState({
    email: '',
    password: ''
  })
  // const [Users, setUsers] = useState([])
  const { users } = useSelector(state => state.usersReducer)

  const history = useHistory()
  const dispatch = useDispatch()

  // useEffect(() => {
  //   console.log(UserLogin);
  //   // fetch('http://localhost:3000/users')
  //   // .then((result) => {
  //   //   return result.json()
  //   // })
  //   // .then((users) => {
  //   //   setUsers(users)
  //   // }).catch((err) => {
  //   //   console.log(err);
  //   // });
  // }, [])

  const handleLogin = (e) => {
    dispatch(getUser(UserLogin))
    e.preventDefault()
    
    setTimeout(() => {
      history.push('/')
    }, 900)
    // for (let i = 0; i < users.length; i++) {
    //   const el = users[i]
    //   if (UserLogin.email === el.email && UserLogin.password === el.password ) {
    //   }
    // }
  }
  
  const handleOnChange = (e) => {
    const { name, value } = e.target
    setUserLogin({...UserLogin, [name]: value})
  }

  return (
    <>
      <main className="form-signin" onSubmit={handleLogin}>
        <div className="container text-center">
          <div className="card col-md-5 mx-auto">
            <div className="card-body ">
              <form>
                <img className="mb-4" src="https://cdn.pixabay.com/photo/2017/01/20/11/04/icon-1994569_960_720.png" alt="" width="200" height="150"/>
                <h1 className="h3 mb-3 fw-normal">Please sign in</h1>

                <div className="form-floating mb-3">
                  <label htmlFor="floatingInput">Email address</label>
                  <input type="email" className="form-control" id="floatingInput" name="email" value={UserLogin.email} placeholder="Enter Your Email" onChange={e => handleOnChange(e)}/>
                </div>
                <div className="form-floating mb-3">
                  <label htmlFor="floatingPassword mb-3">Password</label>
                  <input type="password" className="form-control" id="floatingPassword" name="password" value={UserLogin.password} placeholder="Password" onChange={e => handleOnChange(e)}/>
                </div>
                <button className="mt-3 w-100 btn btn-lg btn-primary" type="submit">Sign in</button>
                <p>Create New Account ?<Link to="/register"> Register</Link></p>
                <p className="mt-5 mb-3 text-muted">&copy; 2017–2021</p>
              </form>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}